export default __webpack_public_path__ + "static/media/primeicons.dfbfef2d.eot";